import { PropAsset } from './PropAsset';

// Well - Kuyu
// TODO: Replace with SVG asset
export class Well extends PropAsset {
  readonly id = 'well';
  readonly width = 45;
  readonly height = 55;
  readonly walkable = false;
  readonly collisionRadius = 0.8;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.2)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 14 * s, 7 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Base stone ring - Taş temel
    ctx.fillStyle = '#6a6a6a';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 5 * s, 14 * s, 7 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Well wall - Kuyu duvarı
    ctx.fillStyle = '#5a5a5a';
    ctx.fillRect(cx - 12 * s, cy - 18 * s, 24 * s, 14 * s);

    // Inner hole (water) - İç delik (su)
    ctx.fillStyle = '#2d4b6a';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 17 * s, 8 * s, 4 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Water shimmer
    ctx.fillStyle = 'rgba(100,180,255,0.3)';
    ctx.beginPath();
    ctx.ellipse(cx - 2 * s, cy - 18 * s, 3 * s, 1.5 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Roof supports - Çatı direkleri
    ctx.fillStyle = '#4a3628';
    ctx.fillRect(cx - 14 * s, cy - 42 * s, 3 * s, 28 * s);
    ctx.fillRect(cx + 11 * s, cy - 42 * s, 3 * s, 28 * s);

    // Roof beam - Çatı kirişi
    ctx.fillRect(cx - 14 * s, cy - 42 * s, 28 * s, 3 * s);

    // Roof - Çatı
    ctx.fillStyle = '#5a3a2a';
    ctx.beginPath();
    ctx.moveTo(cx, cy - 52 * s);  // Peak
    ctx.lineTo(cx - 18 * s, cy - 38 * s);
    ctx.lineTo(cx + 18 * s, cy - 38 * s);
    ctx.closePath();
    ctx.fill();

    // Bucket rope - Kova ipi
    ctx.strokeStyle = '#8b7355';
    ctx.lineWidth = 1.5 * s;
    ctx.beginPath();
    ctx.moveTo(cx, cy - 40 * s);
    ctx.lineTo(cx, cy - 22 * s);
    ctx.stroke();

    // Bucket - Kova
    ctx.fillStyle = '#6b5335';
    ctx.fillRect(cx - 3 * s, cy - 26 * s, 6 * s, 5 * s);
  }
}
